import '../../styles/pages/currencies-page.scss';

import '../components/currencies/dateSelector'

// Change tabs section
/////////////////////////////////////////////////////////
const [
  tabWithRatesInternational,
  tabWithRatesGov] =
  [document.querySelector('.grid__rates-tabs h2[data-tab="international"]'),
  document.querySelector('.grid__rates-tabs h2[data-tab="govBank"]')];


const [
  tableWithRatesInternational,
  tableWithRatesGov] =
  [document.querySelector('.grid__rates table[data-tab="international"]'),
  document.querySelector('.grid__rates table[data-tab="govBank"]')];


const loadMoreBtnFirst = document.querySelector('#load_more_currencies-1');
const loadMoreBtnSecond = document.querySelector('#load_more_currencies-2');

tabWithRatesInternational.addEventListener('click', () => {
  tabWithRatesInternational.classList.add('grid__rates-tabs-item_active');
  tabWithRatesGov.classList.remove('grid__rates-tabs-item_active');

  tableWithRatesInternational.classList.remove('hidden');
  tableWithRatesGov.classList.add('hidden');
  !loadMoreBtnFirst.classList.contains('fully-loaded') && loadMoreBtnFirst.classList.remove('hidden');
  loadMoreBtnSecond.classList.add('hidden');
});

tabWithRatesGov.addEventListener('click', () => {
  tabWithRatesGov.classList.add('grid__rates-tabs-item_active');
  tabWithRatesInternational.classList.remove('grid__rates-tabs-item_active');

  tableWithRatesGov.classList.remove('hidden');
  tableWithRatesInternational.classList.add('hidden');

  !loadMoreBtnSecond.classList.contains('fully-loaded') && loadMoreBtnSecond.classList.remove('hidden');
  loadMoreBtnFirst.classList.add('hidden');
});


const loadMoreBtn = document.querySelector('.load-more');

if (loadMoreBtn) {
  loadMoreBtn.addEventListener('click', (e) => {
    const fullLocationWithoutQuery = window.location.href.split('?')[0].slice(0, -11);
    const contentContainer = document.getElementById('grid-news');

    load_posts_by_page({
      path: `${fullLocationWithoutQuery}/load-financial-posts/`,
      content: contentContainer,
      btn: loadMoreBtn,
    })
  })
}
